$(document).ready(function () {
  // Make pricacy notice into a hyperlink
  const isFirstPage = document.querySelector('#localAccountForm')
  const isSignUpPage = !!document.querySelector('#emailVerificationControlSignUp')
  const isSignInPage = !!document.querySelector('#emailVerificationControl')
  const isChangeEmail = !!document.querySelector('#VerificationControl-ChangeEmail-VerifyCurrentEmail, #VerificationControl-ChangeEmail-NewEmail')
  const isChangeEmailSecondStep = !!document.querySelector('#VerificationControl-ChangeEmail-NewEmail')
  const body = document.querySelector('body')
  let locale = new URLSearchParams(window.location.search).get('site_locale')
  if(locale){
    locale = new URLSearchParams(window.location.search).get('ui_locales') + '-' + locale
  }else{
    locale = new URLSearchParams(new URL(decodeURIComponent(window.location.href).match(/(https?:\/\/[^"]+)/g)?.[1])?.search)?.get("market")
  }
  document.querySelector('meta[name="locale"]').content = locale
  const secondStepProgress = document.querySelector('.progress-bar .step:nth-child(2)');

  fetchLabels()
  if (isFirstPage) {
    document.title = 'Login/Signup'
    firstDecisionPageOverlay()
    setIntroText('firstDecisionPage');
    notifyValidEmail();
    takeDecision()
  } else if (isSignInPage) {
    body.classList.add('is-sign-in')
    document.title = 'Login'
    emailVerificationHandler()
    secondStepProgress.classList.add('active')
    otpBoxesHandler()
  } else if (isSignUpPage) {
    body.classList.add('is-sign-up')
    document.title = 'Signup'
    termsOfServiceText(true)
    setHyperLink()
    emailVerificationHandler()
    secondStepProgress.classList.add('active')
    otpBoxesHandler()
  } else if(isChangeEmail) {
    body.classList.add('is-change-email')
    document.title = 'Change Email'
    emailVerificationHandler()
    setIntroText('changeEamil')
    isChangeEmailSecondStep && secondStepProgress.classList.add('active')
  }
  setBackButtonUrl()
  convertIntoRtl()
  handleUnExpectedError()
  window.onload = function(){
    trackAllPageViews()
 }

  function trackAllPageViews() {
    isFirstPage && trackPageView('Login/Signup','LOGIN',locale)
    isSignInPage && (
      trackAction('Login initiated','Login/Signup','LOGIN',locale),
      trackPageView('LOGIN','LOGIN',locale)
    )
    isSignUpPage && (
      trackAction('create account initiated','Login/Signup','LOGIN',locale),
      trackPageView('Create account','REGISTER',locale)
    )
  }
  function setBackButtonUrl() {
    let backButton = document.querySelector('.back-btn.a-link')
    let logoWeekday = document.querySelector('.logo__weekday')
    logoWeekday.href = `https://www.weekday.com/${locale}/`
    if (backButton) {
      let urlParam = isFirstPage ? new URLSearchParams(window.location.search).get('redirect_uri') : new URLSearchParams(document.referrer).get('redirect_uri')
      let urlParam_state = new URLSearchParams(window.location.search).get('state') || new URLSearchParams(document.referrer).get('state')
      if (urlParam_state) {
        let urlParam_state_splitted = urlParam_state.split('|')
        if (urlParam_state_splitted.length > 1 && urlParam_state_splitted[urlParam_state_splitted.length - 1]) {
          urlParam = urlParam_state_splitted[urlParam_state_splitted.length - 1]
        }
      }
      if (urlParam && urlParam.startsWith('http')) {
        backButton.href = urlParam;
      } else {
        backButton.href = `https://www.hm.com/${locale}/`;
      }
    }
  }
  
  function notifyValidEmail(){
    const emailField = document.querySelector('#email')
    let validIcon = document.createElement('i')
    validIcon.classList.add('valid-email')
    emailField.addEventListener('input',()=>{
      const email_validated = document.querySelector('.valid-email')
      if(emailField.value.match(/\S+@\S+\.\S+/)){
        !email_validated && emailField.after(validIcon) 
        emailField.classList.add('validated-pattern')
      }else{
        validIcon.remove();
        emailField.classList.remove('validated-pattern')
      }
    })
  }

  function setHyperLink(element = document.querySelector('.promotion-consent') , startIndex='{0}', lastIndex='{1}') {
    if (element) {
      const innerHtml = element.innerHTML
      const privacy_text_start_index = innerHtml.indexOf(startIndex)
      const privacy_text_end_index = innerHtml.indexOf(lastIndex)
      const privacyNoticeURL = `https://weekday.com/${locale}/legal/privacy-notice/`
      const hlElement =
        '<a class="a-link" href='+privacyNoticeURL+' target="_blank">' +
        innerHtml.substring(privacy_text_start_index + 3, privacy_text_end_index) +
        '</a>'
      element.innerHTML =
        innerHtml.substring(0, privacy_text_start_index) +
        hlElement +
        innerHtml.substring(privacy_text_end_index + 3)
    }
  }

  function setIntroText(pageName) {
    if(pageName == 'firstDecisionPage'){
      const progressBar = document.querySelector('.progress-bar')
      let headingtag = document.createElement('h1');
      let motivationText = document.createElement('div');
      let privacyNoticeText = document.createElement('div');
      let submitBtn = document.querySelector('#localAccountForm button[type="submit"]')
      //motivationText.innerText =fetchLabels('CUSTOMER.signin.signup.page.join.weekday');
      motivationText.classList.add('motivation-heading')
      headingtag.innerText = fetchLabels('CUSTOMER.signin.signup.page.heading')
      submitBtn.innerText = fetchLabels('CUSTOMER.signin.signup.page.submit.button')
      headingtag.classList.add('page-heading');
      progressBar.before(headingtag)
      progressBar.after(motivationText)
      privacyNoticeText.innerText = fetchLabels('CUSTOMER.signin.privacy.consent')
      privacyNoticeText.classList.add('terms-of-div')
      submitBtn.before(privacyNoticeText)
      setHyperLink(document.querySelector('.terms-of-div'), '{0}','{1}')
    }else if(pageName == 'changeEamil'){
      const introDiv = document.querySelector('.is-change-email .intro')
      introDiv?.classList.add('hidden_element')
      const progressBar = document.querySelector('.progress-bar')
      let headingtag = document.createElement('h1');
      headingtag.innerText = fetchLabels('CUSTOMER.change.email.page.heading')
      headingtag.classList.add('page-heading');
      progressBar.before(headingtag)
      if(isChangeEmailSecondStep){
        introDiv.classList.remove('hidden_element') 
        introDiv.innerText = fetchLabels('CUSTOMER.change.email.enter.new.email.text')
      }
    }
  }

  function termsOfServiceText(isConsentNeeded = false) {
    const termsAndConditionConsent = document.querySelector('#extension_Weekday_termsAndConditions_yes, #extension_weekday_termsAndConditions_yes')
    let weekdayNewsletterConsent = document.createElement('div');
    weekdayNewsletterConsent.classList.add('promotion-consent')
    weekdayNewsletterConsent.innerHTML = fetchLabels('CUSTOMER.signup.checkbox.consent')
    !termsAndConditionConsent?.checked && termsAndConditionConsent?.click();
    document.querySelector('#emailVerificationControlSignUp ul')?.appendChild(document?.querySelector('.CheckboxMultiSelect:nth-child(3)'))
    if (!document.querySelector('.terms-of-div') && isConsentNeeded) {
      var termsOfServiceDiv = document.createElement('div')
      termsOfServiceDiv.classList.add('terms-of-div')
      var consent_text = fetchLabels('CUSTOMER.create.account.terms.of.service.consent')
      var terms_text_start_index = consent_text.indexOf('{0}')
      var terms_text_end_index = consent_text.indexOf('{1}')
      const termsOfServiceURL = `https://weekday.com/${locale}/legal/terms-of-service/`
      var termsOfServiceLink =
        '<a class="a-link" href='+termsOfServiceURL+' target="_blank">' +
        consent_text.substring(terms_text_start_index + 3, terms_text_end_index) +
        '</a>'
      termsOfServiceDiv.innerHTML =
        consent_text.substring(0, terms_text_start_index) +
        termsOfServiceLink +
        consent_text.substring(terms_text_end_index + 3)
        document.querySelector('.VerificationControl .buttons').before(weekdayNewsletterConsent)
      document.querySelector('.VerificationControl .buttons').before(termsOfServiceDiv)
    }
  }

  function fetchLabels(key) {
    const urlParam = new URLSearchParams(window.location.search).get('showKeys')
    if (urlParam == 'true') {
      return
    }
    if (!sessionStorage.getItem(`labels_data_${locale}`)) {
      sessionStorage.setItem(`labels_data_${locale}`, document.querySelector('#lsl_labels').innerText)
      document.querySelector('#lsl_labels').remove()
    }
    const labels_data = JSON.parse(sessionStorage.getItem(`labels_data_${locale}`))
    if (key) {
      const label_data = labels_data.filter((label) => label.key === key)
      if (label_data.length) {
        return label_data[0].translation || label_data[0].value
      } else {
        return key
      }
    } else {
      document.querySelectorAll('div, a, span, label, button, p').forEach(function (item) {
        const labels = labels_data.filter((label) => label.key === item.innerHTML.trim())
        if (labels[0]) {
          item.innerHTML = labels[0].translation || labels[0].value
        }
      })
      document.querySelectorAll('input').forEach(function (item) {
        const labels = labels_data.filter((label) => label.key === item.placeholder.trim())
        if (labels[0]) {
          item.placeholder = labels[0].translation || labels[0].value
          item.ariaLabel = fetchLabels(item.ariaLabel)
          item.title = ''
        }
      })
    }
  }

  function convertIntoRtl() {
    //add languages which needs to be converted into right to left
    const rtl_languages = ['il']
    const isrtl = rtl_languages.map((market) => {
      if (document.location.hostname.indexOf('.' + market + '.') > -1) {
        return true
      }
    })
    if (isrtl[0]) {
      document.body.classList.add('isrtl')
    }
  }

  function fetchLabelsVerificationFlow() {
    let verificationErrorText = document.querySelector('.verificationErrorText div')
    verificationErrorText && (verificationErrorText.innerText = fetchLabels(verificationErrorText.innerText))
    hideOverlay();
  }

  function showOverlay() {
    var spinnerDiv = $('.spinner')
    $('.page-content').addClass('fadeMe')
    spinnerDiv.removeClass('hidespinner').addClass('showspinner')
  }

  function hideOverlay() {
    var spinnerDiv = $('.spinner')
    $('.page-content').removeClass('fadeMe')
    spinnerDiv.removeClass('showspinner').addClass('hidespinner')
    $('.is-next-page-loading').removeClass('is-next-page-loading');
  }

  function emailVerificationHandler() {
    const verifyCodeBtn = document.querySelector('.verifyCode')
    const sendNewCodeBtn = document.querySelector('.sendNewCode')
    const verificationCode_label = $('#VerificationCode_label')
    const sendVerificationCodeBtn = $(
      '#emailVerificationControl_but_send_code ,#emailVerificationControlSignUp_but_send_code, #VerificationControl-ChangeEmail-VerifyCurrentEmail_but_send_code, #VerificationControl-ChangeEmail-NewEmail_but_send_code'
    )
    const intro = $('.intro')
    const signupIntro = document.querySelector('.is-sign-up .intro')
    const continueBtn = document.querySelector('#continue')
    const verificationSuccessTextDiv = document.querySelector('.verificationSuccessText div')
    const verificationFlowEmailField = document.querySelector(
      '#emailVerificationControlSignUp .TextBox.email #email, #emailVerificationControl .TextBox.email #email , #VerificationControl-ChangeEmail-VerifyCurrentEmail .TextBox.email #email , #VerificationControl-ChangeEmail-NewEmail .TextBox.email #email',
    )
    const VerificationCodeInput = document.querySelector('#VerificationCode')
    const newsletter_checkbox = document.querySelector('#extension_Weekday_termsAndConditionsOptional_yes_newsletter')
    if (continueBtn && !isSignUpPage && !isSignInPage && !isChangeEmail) {
      continueBtn.remove()
    }
    VerificationCodeInput.addEventListener('click',function(){
      isSignInPage && trackAction('Verification code input field','LOGIN','LOGIN',locale)
      isSignUpPage && trackAction('Verification code input field','Create account','REGISTER',locale)
    })
    sendNewCodeBtn.addEventListener('click',function(){
      showOverlay()
      isSignInPage && trackAction('Send new code','LOGIN','LOGIN',locale)
      isSignUpPage && trackAction('Send new code','Create account','REGISTER',locale)
    })
    //Change Email verification labels - Start
    if (sendVerificationCodeBtn) {
      intro.empty()
      $('.verificationControlContent').prepend(intro)
      sendVerificationCodeBtn.text(fetchLabels('CUSTOMER.send.verification.code.button.text'))
    }
    // Change Verification code label
    if (verificationCode_label && verificationCode_label.is('label')) {
      verificationCode_label.empty()
      verificationCode_label.append(fetchLabels('CUSTOMER.verification.code.label.text'))
      verifyCodeBtn.innerText = isSignUpPage ? fetchLabels('CUSTOMER.verify.code.button.text') : isSignInPage ? fetchLabels('CUSTOMER.verify.code.signin.button.text') : fetchLabels('CUSTOMER.verify.code.change.email.button.text')
      sendNewCodeBtn.innerText = fetchLabels('CUSTOMER.send.new.code.button.text')
    }
    //Change Email verification labels - End
    //Show Spinner on click of "Send Verification Code Button"
    sendVerificationCodeBtn.click(function () {
      if ($(this).css('display') === 'none') {
        showOverlay()
      }
    })

    //Auto Click on Send Verification Button
    verificationFlowEmailField?.setAttribute('readonly', 'true')
    !isChangeEmailSecondStep && sendVerificationCodeBtn.click()

    //Hide Spinner and Overlay when code verification is done
    $(function () {
      var verifyBtnObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          // If current changes are on style and verify button is hidden, hide the overlay and spinner
          if (
            verifyCodeBtn &&
            (mutation.attributeName === 'style' || mutation.attributeName === 'aria-hidden')
          ) {
            if (
              verifyCodeBtn.style.display === 'none' ||
              (verifyCodeBtn.style.display !== 'none' && !VerificationCodeInput.value)
            ) {
              hideOverlay()
              if (signupIntro) {
                signupIntro.style.display = 'none'
              }
            }
          }
          if (mutation.attributeName === 'style') {
            fetchLabelsVerificationFlow()
          }
        })
      })

      // Observer registration of verify button to track state changes
      if (verifyCodeBtn) {
        verifyBtnObserver.observe(verifyCodeBtn, {
          attributes: true,
        })
      }

      //Varification Success msg
      var verificationSuccessTextObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function () {
          let success_msg = verificationSuccessTextDiv.innerText
          if (
            success_msg == 'Verification code has been sent. Please copy it to the input box below.'
          ) {
            if(isChangeEmail && !isChangeEmailSecondStep){
              let email_input_field = document.querySelector('#email');
              let currentEmailDiv = document.createElement('div')
              currentEmailDiv.classList.add('current-email-value')
              email_input_field.classList.add('hidden_element')
              currentEmailDiv.innerText = email_input_field.value
              success_msg = fetchLabels('CUSTOMER.current.email.sub.heading')
              verificationSuccessTextDiv.classList.add('current-email-sub-heading')
              verificationSuccessTextDiv.after(currentEmailDiv)
            }else{
              let email_value = document.getElementById('email').value;
              success_msg = fetchLabels('CUSTOMER.verification.code.sent.info.text')
              let success_msg_start_index = success_msg.indexOf('{0}')
              let success_msg_end_index = success_msg.indexOf('{1}')
              success_msg_start_index > -1 && (
                success_msg = success_msg.substring(0, success_msg_start_index) + `${email_value}` + success_msg.substring(success_msg_end_index + 3)
              )
              const introDiv = document.querySelector('.is-change-email .intro')
              isChangeEmailSecondStep && introDiv?.classList.add('hidden_element') 
            }
          } else if (success_msg == 'The code has been verified. You can now continue.') {
            success_msg = fetchLabels('CUSTOMER.verification.code.verified.info.text')
            if((isSignUpPage || isSignInPage || isChangeEmail) && !$('.page-content').hasClass('fadeMe')){
              continueBtn.click();
              showOverlay();
              isSignUpPage && trackAction(`NL Signup checkbox:${newsletter_checkbox?.checked}`,'Create account','REGISTER',locale)
            }
          }
          verificationSuccessTextDiv.innerText = success_msg
        })
        verificationSuccessTextDiv.innerHTML = verificationSuccessTextDiv.innerText;
      })

      let verificationSuccessText = verificationSuccessTextDiv
      // Observer registration of continue button to track state changes
      if (verificationSuccessText) {
        verificationSuccessTextObserver.observe(verificationSuccessText, {
          attributes: true,
        })
      }
    })

    function invalidOtpMessageHandler(isVisible){
      if (isVisible) {
        document.querySelectorAll('.otp-field-container input[type="number"]').forEach(input => {
          input.classList.add('otp-error');
        });
      }
    }
    // Show spinner and overlay on click of verify code button.
    verifyCodeBtn.addEventListener('click', function () {
      showOverlay()
      //Sign up wrong otp error message handler
      if(isSignUpPage){
        const wrongOtpErrorMessage = document.querySelector('#emailVerificationControlSignUp_error_message');
        const observer = new MutationObserver(() => {
          const isVisible = window.getComputedStyle(wrongOtpErrorMessage).display === 'inline';
          invalidOtpMessageHandler(isVisible);
        });
        observer.observe(wrongOtpErrorMessage, {
          attributes: true,
          attributeFilter: ['style'],
        });
      }

      // Sign in wrong otp error message handler
      if(isSignInPage){
        const wrongOtpErrorMessageSignIn = document.querySelector('#emailVerificationControl_error_message');
        const observerSignIn = new MutationObserver(() => {
          const isVisible = window.getComputedStyle(wrongOtpErrorMessageSignIn).display === 'inline';
          invalidOtpMessageHandler(isVisible)
        });
        observerSignIn.observe(wrongOtpErrorMessageSignIn, {
          attributes: true,
          attributeFilter: ['style'],
        });
      }
    })

    //Logic to identify Signup page, as it has different layout. Hide Spinner on signup page when verification of the code is done
    let continueBtnObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function () {
        if (
          verifyCodeBtn.style.display === 'none' &&
          !$('#continue').css('aria-disabled') &&
          isSignUpPage
        ) {
          hideOverlay()
        }
      })
    })
    // Observer registration of continue button to track state changes
    if (continueBtn) {
      continueBtnObserver.observe(continueBtn, {
        attributes: true,
      })
    }
    // Show spinner and overlay on click of continue button after entering pwds. Sign-up
    continueBtn.addEventListener('click', function () {
      if (
        (!verifyCodeBtn || verifyCodeBtn.style.display === 'none') &&
        !continueBtn.getAttribute('aria-disabled') &&
        isSignUpPage
      ) {
        showOverlay()
      }
    })
    if (verifyCodeBtn) {
      // Adding auto submission of email verifcation after email is verified
      verifyCodeBtn.onclick = function () {
        if (!isSignUpPage) {
          /* Continue the page once email is validated.
          $element is a window object set by B2C and 
          it updates the boolean value of "$element.verificationInfo.emailVerificationControl"  once email is verified 
          */
          const verifyInterval = setInterval(function () {
            if ($element.verificationInfo.emailVerificationControl) {
              clearInterval(verifyInterval)
              $element.verify()
            }
          }, 0)
        }
      }
    }
  }

  //Weekday otp
  function otpBoxesHandler() {
    const inputs = document.querySelectorAll('.otp-field');
    const verificationCodeInput = document.querySelector('#VerificationCode');
    const otpFieldContainer = document.querySelector('.otp-field-container');
    const verifyCode = document.querySelector('.verifyCode');
    if(otpFieldContainer){
      otpFieldContainer.style.display = 'inline-flex';
      const joinInputsValue = ()=>{
        let otp='';
        inputs.forEach((input, index)=>{
            otp += input.value
        })
        verificationCodeInput.value = otp;
        const verificationCode = document.querySelector('#VerificationCode')
        if(verificationCode.value.match(/^\d{6}$/)){
          verifyCode.removeAttribute('disabled')
        }else{
          verifyCode.setAttribute('disabled', 'disabled')
        }
      }

            inputs.forEach((input, index) => {
                input.addEventListener('input', (e) => {
                    input.value = e.data ? e.data.slice(-1) : input.value.slice(-1);
                    if (input.value.length === 1 && index < inputs.length - 1) {
                        inputs[index + 1].focus();
                    }else if(index == inputs.length - 1 && inputs[index].value.length === 1){
                      verifyCode.focus();
                      verifyCode.scrollIntoView({ behavior: "smooth" })
                    }
                    joinInputsValue()
                });

                input.addEventListener('keydown', (e) => {
                    if (e.key === 'Backspace' && input.value === '' && index > 0) {
                        inputs[index - 1].focus();
                    }
                    joinInputsValue()
                });
                input.addEventListener('paste', (e) => {
                    e.preventDefault();
                    const pasteData = (e.clipboardData || window.clipboardData).getData('text');
                    const pasteValues = pasteData.split('').slice(0, inputs.length);  // Limit to the number of input fields

                    pasteValues.forEach((value, pasteIndex) => {
                        inputs[pasteIndex].value = value;
                        if(pasteIndex == inputs.length-1){
                          verifyCode.scrollIntoView({ behavior: "smooth" })
                          verifyCode.focus();
                        }
                    });

                    if (pasteValues.length > 0) {
                        const nextInputIndex = pasteValues.length < inputs.length ? pasteValues.length : inputs.length - 1;
                        inputs[nextInputIndex].focus();
                    }
                    joinInputsValue()
                });
            });
          const VerificationCodeInputBox = document.querySelector('.VerificationCode .attrEntry');
          VerificationCodeInputBox.before(otpFieldContainer)
          VerificationCodeInputBox.after(document.querySelector('.verificationErrorText'))
          inputs[0].focus();
    }
  }

  function firstDecisionPageOverlay() {
    let remember_me_checkbox = document.querySelector('.rememberMe #rememberMe');
    !remember_me_checkbox?.checked && remember_me_checkbox?.click();
    let email_input = document.querySelector('#email')
    let google_btn = document.querySelector('#GoogleExchange')
    let facebook_btn = document.querySelector('#FacebookExchange')
    google_btn.innerHTML = `<span class="social-media-button">${google_btn.innerHTML}</span>`
    facebook_btn.innerHTML = `<span class="social-media-button">${facebook_btn.innerHTML}</span>`
    email_input.addEventListener('click',function(){
      trackAction('Login/signup Start','Login/Signup','LOGIN',locale)
    });
    google_btn.addEventListener('click',function(){
      trackAction('Social login start','Login/Signup','LOGIN',locale,'Google')
    });
    facebook_btn.addEventListener('click',function(){
      trackAction('Social login start','Login/Signup','LOGIN',locale,'Facebbok')
    });
    // Show spinner and overlay on click of continue button after entering Email on First page.
    $('#next').click(function () {
      const createAccountBtn = document.querySelector('#createAccount')
      // Execute if First page page
      if (createAccountBtn) {
        showOverlay()
        this.addClass('is-next-page-loading')
      }
    })
  }

  function handleUnExpectedError() {
    // Generic code to hide Overlay spinner when any error(backend/frontend) is displayed on the page.
      // Create a MutationObserver to observe changes in the DOM
    const observer = new MutationObserver(function(mutationsList, observer) {
      mutationsList.forEach(function(mutation) {
        if((mutation.attributeName === 'style' || mutation.attributeName === 'aria-hidden')){
          handleErrors();
        }
      });
    });

    // Configuration of the observer: observe child list changes, subtree, and attributes
    const config = { childList: true, subtree: true, attributes: true };

    // Start observing each '.error' element
    document.querySelectorAll('.error').forEach(function(element) {
      observer.observe(element, config);
    });
    function handleErrors() {
      setTimeout(() => {
          document.querySelectorAll('.error').forEach(function(errorElement) {
              if (errorElement.getAttribute('aria-hidden') === 'false' || 
                  errorElement.querySelector('[id*=error]')?.getAttribute('aria-hidden') === 'false') {
                  hideOverlay();
                  const wrongOTPErrorMessage = errorElement.querySelector('[id*=error]')
                  const inputs = document.querySelectorAll('.otp-field');
                  const lastInputBox = inputs?.length - 1;
                  inputs[lastInputBox].focus();
                  if(wrongOTPErrorMessage?.getAttribute('id') === 'emailVerificationControlSignUp_error_message'){
                    inputs[lastInputBox].setAttribute('aria-describedby', 'emailVerificationControlSignUp_error_message');
                    wrongOTPErrorMessage.setAttribute('aria-label', wrongOTPErrorMessage.innerText);
                  }
                  if(wrongOTPErrorMessage?.getAttribute('id') === 'emailVerificationControl_error_message'){
                    inputs[lastInputBox].setAttribute('aria-describedby', 'emailVerificationControl_error_message');
                    wrongOTPErrorMessage.setAttribute('aria-label', wrongOTPErrorMessage.innerText);
                  }
              }
          });
      }, 0);

      let signinErrorMsg = document.querySelector('.is-sign-in label[for="signInName"]+.error p, .localAccount label[for="email"]+.error p');
      // let emailErrorLabel = fetchLabels('CUSTOMER.signin.enter.email.error');
      let emailErrorLabel = fetchLabels('CUSTOMER.create.account.email.validation.error.text');

      if (signinErrorMsg && signinErrorMsg.innerText !== '' && signinErrorMsg.innerText.indexOf(emailErrorLabel) === -1) {
          signinErrorMsg.innerText = emailErrorLabel;
      }
      observer.disconnect();
      document.querySelectorAll('.error').forEach(function(errorElement) {
          let specificErrorMessage = errorElement.textContent.trim();
          switch (specificErrorMessage) {
              case 'CUSTOMER.phone.number.error.text':
                  errorElement.textContent = fetchLabels('CUSTOMER.phone.number.error.text');
                  break;
              case 'CUSTOMER.signin.enter.password.error':
                  errorElement.textContent = fetchLabels('CUSTOMER.signin.enter.password.error');
                  break;
              case 'CUSTOMER.signup.enter.information.error':
                  errorElement.textContent = fetchLabels('CUSTOMER.signup.enter.information.error');
                  break;
              case 'CUSTOMER.signup.newpassword.pattern.error':
                  errorElement.textContent = fetchLabels('CUSTOMER.signup.newpassword.pattern.error');
                  break;
              case 'CUSTOMER.signin.invalid.user.password.error':
                  errorElement.textContent = fetchLabels('CUSTOMER.signin.invalid.user.password.error');
                  break;
              case 'CUSTOMER.signup.password.mismatch.error':
                  errorElement.textContent = fetchLabels('CUSTOMER.signup.password.mismatch.error');
                  break;
              case 'CUSTOMER.signin.block.user.error':
                  errorElement.textContent = fetchLabels('CUSTOMER.signin.block.user.error');
                  break;
              case 'A user with the specified ID already exists. Please choose a different one.':
                  errorElement.textContent = fetchLabels('CUSTOMER.create.account.already.exist.error.text');
                  break;
              case 'Please enter a valid email address.':
                  errorElement.textContent = fetchLabels('CUSTOMER.create.account.email.validation.error.text');
                  break;
              case 'CUSTOMER.verification.exceeded.code.generation.error.text':
                  errorElement.textContent = fetchLabels('CUSTOMER.verification.exceeded.code.generation.error.text');
                  break;
              case 'Boolean claim value comparison failed for claim type "inputClaim".':
                  errorElement.textContent = fetchLabels('CUSTOMER.signin.block.user.error');
                  break;
          }
      });
      document.querySelectorAll('.error').forEach(function(element) {
        observer.observe(element, config);
      });
    }
  }

function  takeDecision(){
    fetch("https://fabulous.hmgroup.com/files/datafile_weekday.json")
  .then((response) => response.body)
  .then((rb) => {
    const reader = rb.getReader();

    return new ReadableStream({
      start(controller) {
        // The following function handles each data chunk
        function push() {
          // "done" is a Boolean and value a "Uint8Array"
          reader.read().then(({ done, value }) => {
            // If there is no more data to read
            if (done) {
              controller.close();
              return;
            }
            // Get the data and send it to the browser via the controller
            controller.enqueue(value);
            // Check chunks by logging to the console
            console.log(done, value);
            push();
          });
        }

        push();
      },
    });
  })
  .then((stream) =>{
    // Respond with our stream
    return new Response(stream, { headers: { "Content-Type": "text/html" } }).text()
  })
  .then((result) => {
    let decisionSocialLogin = JSON.parse(result)?.flags['social_login_toggle_test']?.experiments[0]?.variations[1]?.variables[0]?.value
    decisionSocialLogin =='false' && (document.querySelector('.social').classList.add('hidden_element'), document.querySelector('.divider').remove())
    let decisionLocalLogin = JSON.parse(result)?.flags['LOCAL_LOGIN_TOGGLE_TEST']?.experiments[0]?.variations[1]?.variables[0]?.value
    decisionLocalLogin =='false' && (
      document.querySelector('#localAccountForm').classList.add('hidden_element'), 
      document.querySelector('.divider h2').innerHTML = 'YOU CAN LOGIN WITH GOOGLE OR FACEBOOK ACCOUNT. LOGIN WITH PASSWORD IS NOT AVAILABLE AT THE MOMENT.'
    )
  });
  }

  /************************  Tracking Utilities      ***********************/
  const userAgent = navigator.userAgent.toLowerCase();
  const touchPoint = (/iphone|ipod|android|blackberry|opera mini|windows phone|iemobile|mobile/i.test(userAgent) && 'Mobile') || (/ipad|android|kindle|silk/i.test(userAgent) && 'Tablet') || 'DESKTOP'


  function trackEvent(eventName, data){
      //eventName 'view' for page views, or 'link' for events.
      utag.track(eventName, data);
  }

  function trackPageView(page_name='LOGIN',page_type='LOGIN',locale){
      trackEvent("view",{
          funnel_step: page_name,   // event
          funnel_location: page_name,
          page_category_id: page_type,
          page_id: page_type,
          page_type: page_type,
          region_locale: locale,
          region_market: locale.split('_')[1],
          site_brand_id: "weekday",
          site_touchpoint: touchPoint
          }
      );
  }

  function trackAction(action_name,page_name='LOGIN',page_type='LOGIN',locale, event_name= action_name ){
      trackEvent("link",{
          funnel_step: action_name,   // event
          funnel_location: page_name,
          page_category_id: page_type,
          page_id: page_type,
          page_type: page_type,
          region_locale: locale,
          region_market: locale.split('_')[1],
          site_brand_id: "weekday",
          site_touchpoint: touchPoint,
          event_name: event_name
          }
      );
  }
})
